const ActionStatus = Object.freeze({
  YetToStart: 1,
  Inprogress: 2,
  Completed: 3
});

export default ActionStatus;
